import { render, staticRenderFns } from "./NavbarAluno.vue?vue&type=template&id=028ec94b&scoped=true"
import script from "./NavbarAluno.vue?vue&type=script&lang=js"
export * from "./NavbarAluno.vue?vue&type=script&lang=js"
import style0 from "./NavbarAluno.vue?vue&type=style&index=0&id=028ec94b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028ec94b",
  null
  
)

export default component.exports